import { render, staticRenderFns } from "./DepositBreakdown.vue?vue&type=template&id=1a437aae&"
import script from "./DepositBreakdown.vue?vue&type=script&lang=js&"
export * from "./DepositBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./DepositBreakdown.vue?vue&type=style&index=0&id=1a437aae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports